import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Checkbox, FormControlLabel, Modal, Typography } from "@mui/material";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { sxCheckbox } from "../../../../assets/styles/CommonSxProps";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";
import { RegrasReembolsolProps } from "../../../../interfaces/props/Financeiro/Reembolso/RegrasReembolsoModal";
import { getRegrasDoReembolso } from "../../../../services/Financeiro/ReembolsoService";
import "./styles.css";
import { sxOutlinedButton, sxTermsOfUseModal } from "./sxProps";

function RegrasReembolsoModal(props: RegrasReembolsolProps) {
  const [terms, setTerms] = useState<string>("");
  const [accepted, setAccepted] = useState<boolean>(false);

  useEffect(() => {
    const getTerms = async () => {
      const result = await getRegrasDoReembolso();
      if (result !== null) {
        console.log(result);
        setTerms(result.data);
      }
    };

    getTerms();
  }, []);

  const handleCloseModal = () => {
    props.closeTermsOfUse();
  };

  const handleConfirm = () => {
    props.acceptedTermsOfUse();
  };

  return (
    <div>
      <Modal
        open={props.open}
        onClose={
          props.isCalledBySelecaoBeneficiario ? () => {} : handleCloseModal
        }
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={sxTermsOfUseModal}>
          <div className="terms-of-use-holder">
            <div className="terms-of-use-modal-header">
              <h1 className="terms-title">Regras de reembolso</h1>{" "}
              <button
                className="terms-of-use-modal-header-close"
                onClick={handleCloseModal}
                aria-label="fechar regras de reembolso"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="terms-description-holder">
              <div tabIndex={0} className="terms-description">{parse(terms)}</div>
            </div>
            {props.isCalledBySelecaoBeneficiario && (
              <>
                <div className="terms-checkbox">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={accepted}
                        onChange={() => setAccepted(!accepted)}
                      />
                    }
                    label="Eu li e concordo com os termos"
                    sx={sxCheckbox}
                  />
                </div>
                <div className="box-terms-of-use-buttons-holder">
                  <div className="terms-of-use-buttons">
                    <DefaultButton
                      variant="outlined"
                      onClick={handleCloseModal}
                      fullWidth
                      sx={sxOutlinedButton}
                    >
                      <Typography style={{ color: "#00995D" }}>
                        CANCELAR
                      </Typography>
                    </DefaultButton>
                  </div>
                  <div className="terms-of-use-buttons">
                    <DefaultButton
                      variant="contained"
                      size="large"
                      onClick={handleConfirm}
                      fullWidth
                      disabled={!accepted}
                      text={"CONFIRMAR"}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default RegrasReembolsoModal;
